import { environment as appEnvironment } from 'src/app/environments/testing.environment';
import { environment as coreEnvironment } from 'src/core/environments/testing.environment';
import { Environment } from './environment.type';

export const environment: Environment = {
  ...coreEnvironment,
  ...appEnvironment,
};
